import { MifeParcel } from '@/components/MifeParcel';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/calculators/acceptance-principle/result')({
  component: () => <MifeParcel />,
});
